import { Component } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { AuthService } from '../../../services/auth.service'
import { FlashMessageService } from '../../../services/flash-message.service'

@Component({
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [AuthService]
})
export class ForgotPasswordComponent {
  form: UntypedFormGroup = this.formBuilder.group({
    email: ['', [Validators.email, Validators.required]]
  })

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private flashMessageService: FlashMessageService,
    private router: Router
  ) {}

  submit() {
    this.authService.sendResetPasswordEmail(this.form.value.email).subscribe(
      () => {
        this.flashMessageService.success(
          'Check your email for a link to reset your password. If it doesn’t appear within a few minutes, check your spam folder.'
        )

        return this.router.navigate(['/'])
      },
      (err) => {
        this.flashMessageService.error(err.error.message)
        this.form.reset()
      }
    )
  }
}
